import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
    indexCheck: 0,
};

export const name = "steppay";

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData: (state, action) => {
            state.data = action.payload;
        },
        setIndexCheck: (state, action) => {
            state.indexCheck = action.payload;
        },
        reset: (state) => {
            state.data = []
            state.indexCheck = 0
        }
    },
});

export const { actions, reducer } = slice;

export const getData = (state) => state.steppay.data;
export const getIndexCheck = (state) => state.steppay.indexCheck;
